import { select, Selection } from 'd3-selection'

import PointService from 'live/services/charts/point'
import TooltipService from 'live/services/charts/tooltip'
import dateService from 'live/services/date'
import { defaultOptions, TooltipOptions } from 'highcharts'
import QueryString from './QueryString'
import { format } from 'd3-format'
import colors from 'live/services/colors'
export const getColor = (index: number): string => colors.color(`${index}`)
export const secondsFormat = format('02d')

export default class Tooltip {
    private el: Selection<HTMLElement, null, HTMLElement, null>
    private tooltip: Selection<HTMLDivElement, null, HTMLElement, null>
    private threshold = 30
    private crosshairDistance = 26

    constructor(el: Selection<HTMLElement, null, HTMLElement, null>) {
        const options = TooltipService.createTooltip('group', false, 'line', false, [])
        this.el = el
        this.tooltip = this.el
            .append('div')
            .classed('connection-fingerprint-tooltip', true)
            .style(
                'background-color',
                options.backgroundColor ?? (defaultOptions.tooltip?.backgroundColor || '#f7f7f7')
            )
            .style('border-radius', options.borderRadius ?? (defaultOptions.tooltip?.borderRadius || 0))
            .style('border-color', options.borderColor ?? (defaultOptions.tooltip?.borderColor || '#C8CCD4'))

        this.tooltip.append('div').classed('tooltip-contents', true)
    }

    render(
        x: number,
        y: number,
        index: number,
        value: number,
        color: string,
        timestamp: number,
        valueUom: string,
        dimensions: [number, number]
    ): void {
        this.tooltip
            .style('display', 'block')
            .style('visibility', 'visible')
            .style('left', x + this.crosshairDistance + 'px')
            .style('top', y + 'px')
            .select('div.tooltip-contents')
            .selectAll('div')
            .data([
                { name: 'timestamp', value: timestamp },
                {
                    name: 'Duration',
                    value: `${Math.floor(index / 1000 / 60)}m${secondsFormat((index % 60000) / 1000)}s`
                },
                { name: 'Value', value, uom: valueUom }
            ])
            .join('div')
            .html(d =>
                d.name === 'timestamp'
                    ? `<span style="color: ${color}; font-size: 13px">●</span> <span class="tooltip-date-time">${dateService.formatDateTime(
                          d.value
                      )}</span>`
                    : `<span class="tooltip-data-title">${d.name}</span>: <span class="tooltip-data-value">${d.value} ${
                          d.uom || ''
                      }</span>`
            )

        const overY = y + this.threshold > dimensions[1]
        if (overY) {
            const { height } = this.tooltip.node().getBoundingClientRect()
            this.tooltip.style('top', y - height - 30 + 'px')
        }
    }
}
